/* eslint-disable max-lines */
import { IconPack } from '@fortawesome/fontawesome-common-types';
import {
  faAlbumCollection,
  faAlignLeft,
  faAngleDown,
  faAngleUp,
  faArrowDown,
  faArrowDownLong,
  faArrowDownRight,
  faArrowDownToLine,
  faArrowLeft,
  faArrowLeftLong,
  faArrowRight,
  faArrowRightLong,
  faArrowsRotate,
  faArrowUp,
  faArrowUpRight,
  faArrowUpRightFromSquare,
  faBackward,
  faBadgeCheck,
  faBan,
  faBars,
  faBarsProgress,
  faBarsSort,
  faBaseball,
  faBell,
  faBlockBrickFire,
  faBolt,
  faBoltLightning,
  faBook,
  faBooks,
  faBookSection,
  faBorderOuter,
  faBox,
  faBracketsCurly,
  faBroomWide,
  faBrowser,
  faBullseyeArrow,
  faCabinetFiling,
  faCalendarDay,
  faCarrot,
  faChartBullet,
  faChartGantt,
  faChartLine,
  faChartNetwork,
  faChartPie,
  faChartPieSimpleCircleDollar,
  faChartSimple,
  faChartTreeMap,
  faCheck,
  faCheckCircle,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faCircle,
  faCircleCheck,
  faCircleDollar,
  faCircleExclamation,
  faCircleInfo,
  faCirclePlay,
  faCirclePlus,
  faCircleQuestion,
  faCircleStop,
  faCircleUser,
  faCircleVideo,
  faCircleXmark,
  faClapperboardPlay,
  faClock,
  faClockRotateLeft,
  faClosedCaptioning,
  faCloudBinary,
  faCloudExclamation,
  faCloudWord,
  faCode,
  faCodeBranch,
  faCodeFork,
  faCodeSimple,
  faCommentsQuestionCheck,
  faCompress,
  faCookieBite,
  faCopy,
  faCreditCard,
  faCube,
  faDatabase,
  faDollarSign,
  faDownload,
  faDragon,
  faEarthAmericas,
  faEllipsis,
  faEnvelopeOpen,
  faExclamation,
  faExclamationSquare,
  faEye,
  faEyeSlash,
  faFaceAngry,
  faFaceFrown,
  faFaceGrinStars,
  faFaceMeh,
  faFaceSmile,
  faFile,
  faFileArrowUp,
  faFileAudio,
  faFileCheck,
  faFileCode,
  faFileCsv,
  faFileExcel,
  faFileImage,
  faFileImport,
  faFileInvoice,
  faFileLines,
  faFilePdf,
  faFilePowerpoint,
  faFileShield,
  faFileSpreadsheet,
  faFileVideo,
  faFileWord,
  faFileZipper,
  faFilm,
  faFilms,
  faFilter,
  faFlag,
  faFlagCheckered,
  faFloppyDisk,
  faFolder,
  faFolderArrowUp,
  faFolderPlus,
  faForward,
  faFutbol,
  faGamepadAlt,
  faGauge,
  faGaugeLow,
  faGear,
  faGearComplex,
  faGears,
  faGlobe,
  faGraduationCap,
  faGrid,
  faGrid2,
  faGridHorizontal,
  faGripDotsVertical,
  faGripLines,
  faHand,
  faHardDrive,
  faHeartCircle,
  faHeartPulse,
  faHeartSquare,
  faHexagonExclamation,
  faHockeySticks,
  faHouseBlank,
  faHouseNight,
  faImage,
  faInfinity,
  faInputText,
  faKey,
  faKeyboard,
  faLayerGroup,
  faLink,
  faLinkHorizontal,
  faLinkSimple,
  faList,
  faListCheck,
  faListDropdown,
  faListTree,
  faLoader,
  faLocationDot,
  faLock,
  faLockKeyhole,
  faLockOpen,
  faMagnifyingGlass,
  faMapLocationDot,
  faMapMarkerAlt,
  faMapPin,
  faMedal,
  faMemory,
  faMicrochipAi,
  faMinus,
  faMoneyFromBracket,
  faNetworkWired,
  faNotdef,
  faOutdent,
  faPause,
  faPencil,
  faPenToSquare,
  faPersonToPortal,
  faPiggyBank,
  faPlay,
  faPlug,
  faPlugCircleCheck,
  faPlugCircleXmark,
  faPlus,
  faPlusCircle,
  faPowerOff,
  faProjectDiagram,
  faQuestion,
  faRabbit,
  faRabbitRunning,
  faRectangleAd,
  faRectangleVideoOnDemand,
  faRightFromBracket,
  faRobot,
  faRocketLaunch,
  faRotateLeft,
  faRotateRight,
  faScaleBalanced,
  faScaleUnbalancedFlip,
  faScrewdriverWrench,
  faSensorTriangleExclamation,
  faServer,
  faShieldCheck,
  faShieldCross,
  faShieldHalved,
  faShieldKeyhole,
  faShieldSlash,
  faShieldVirus,
  faShuffle,
  faSignHanging,
  faSitemap,
  faSliders,
  faSnooze,
  faSparkles,
  faSquareBolt,
  faSquarePen,
  faSquareQuestion,
  faStar,
  faStarExclamation,
  faStars,
  faStopwatch,
  faSubtract,
  faSymbols,
  faTableCellsLock,
  faTag,
  faTennisBall,
  faTerminal,
  faThumbsDown,
  faThumbsUp,
  faTilde,
  faTimer,
  faTowerBroadcast,
  faTrash,
  faTrashCan,
  faTriangleExclamation,
  faTrophyStar,
  faUpload,
  faUpRightAndDownLeftFromCenter,
  faUser,
  faUserChart,
  faUserCircle,
  faUserCrown,
  faUserGroupCrown,
  faUserSecret,
  faVideo,
  faVideoSlash,
  faVolume,
  faVolumeSlash,
  faWallet,
  faWandMagicSparkles,
  faWarning,
  faWaveform,
  faXmark,
} from '@fortawesome/pro-solid-svg-icons';

import { faAirplayIcon } from './custom-brands/fas-apple-airplay-icon';

export const proSolidSvgIconsPack: IconPack = {
  faCheckCircle,
  faAirplayIcon,
  faAlbumCollection,
  faAlignLeft,
  faAngleDown,
  faAngleUp,
  faArrowDown,
  faArrowDownRight,
  faArrowDownLong,
  faArrowDownToLine,
  faArrowLeft,
  faArrowLeftLong,
  faArrowRight,
  faArrowRightLong,
  faArrowsRotate,
  faArrowUp,
  faArrowUpRight,
  faArrowUpRightFromSquare,
  faBackward,
  faBadgeCheck,
  faHexagonExclamation,
  faBan,
  faBars,
  faBracketsCurly,
  faBarsProgress,
  faBarsSort,
  faBaseball,
  faBell,
  faBlockBrickFire,
  faBook,
  faBooks,
  faBookSection,
  faBorderOuter,
  faBox,
  faBroomWide,
  faBrowser,
  faBullseyeArrow,
  faCabinetFiling,
  faCalendarDay,
  faCarrot,
  faChartBullet,
  faChartGantt,
  faChartLine,
  faChartNetwork,
  faChartPie,
  faChartPieSimpleCircleDollar,
  faChartSimple,
  faChartTreeMap,
  faCheck,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faCircle,
  faCircleCheck,
  faCircleVideo,
  faDatabase,
  faPlusCircle,
  faCircleDollar,
  faCircleExclamation,
  faCircleInfo,
  faCirclePlay,
  faCirclePlus,
  faCircleQuestion,
  faCircleStop,
  faCircleUser,
  faCircleXmark,
  faClapperboardPlay,
  faClock,
  faClockRotateLeft,
  faClosedCaptioning,
  faCloudBinary,
  faCloudWord,
  faCloudExclamation,
  faCode,
  faCodeBranch,
  faCodeFork,
  faCodeSimple,
  faCommentsQuestionCheck,
  faCompress,
  faCookieBite,
  faCopy,
  faCreditCard,
  faCube,
  faDollarSign,
  faDownload,
  faDragon,
  faEarthAmericas,
  faEllipsis,
  faEnvelopeOpen,
  faExclamation,
  faExclamationSquare,
  faEye,
  faEyeSlash,
  faFaceAngry,
  faFaceFrown,
  faFaceGrinStars,
  faFaceMeh,
  faFaceSmile,
  faFile,
  faFileArrowUp,
  faFileAudio,
  faFileCheck,
  faFileCode,
  faFileCsv,
  faFileExcel,
  faFileImage,
  faFileImport,
  faFileLines,
  faFileSpreadsheet,
  faFilePdf,
  faFilePowerpoint,
  faFileShield,
  faFileInvoice,
  faFileVideo,
  faFileWord,
  faFileZipper,
  faFilm,
  faFilms,
  faFilter,
  faFlag,
  faFlagCheckered,
  faFloppyDisk,
  faFolder,
  faFolderArrowUp,
  faFolderPlus,
  faForward,
  faFutbol,
  faGamepadAlt,
  faGauge,
  faGaugeLow,
  faGear,
  faGearComplex,
  faGears,
  faGlobe,
  faGraduationCap,
  faGripDotsVertical,
  faGrid,
  faGrid2,
  faGridHorizontal,
  faGripLines,
  faHand,
  faHardDrive,
  faHeartCircle,
  faHeartPulse,
  faHeartSquare,
  faHockeySticks,
  faHouseBlank,
  faHouseNight,
  faImage,
  faInputText,
  faKey,
  faKeyboard,
  faLayerGroup,
  faLink,
  faLinkHorizontal,
  faLinkSimple,
  faList,
  faListCheck,
  faListTree,
  faListDropdown,
  faLoader,
  faLocationDot,
  faLock,
  faLockOpen,
  faLockKeyhole,
  faMagnifyingGlass,
  faMapLocationDot,
  faMapMarkerAlt,
  faMapPin,
  faMedal,
  faMemory,
  faMicrochipAi,
  faMinus,
  faMoneyFromBracket,
  faNetworkWired,
  faNotdef,
  faOutdent,
  faPause,
  faPencil,
  faPenToSquare,
  faPersonToPortal,
  faPiggyBank,
  faBolt,
  faBoltLightning,
  faPlay,
  faPlug,
  faPlugCircleCheck,
  faPlugCircleXmark,
  faPlus,
  faShieldCross,
  faPowerOff,
  faProjectDiagram,
  faQuestion,
  faRabbit,
  faRabbitRunning,
  faRectangleAd,
  faRectangleVideoOnDemand,
  faRightFromBracket,
  faRobot,
  faRocketLaunch,
  faRotateLeft,
  faRotateRight,
  faScaleBalanced,
  faScaleUnbalancedFlip,
  faScrewdriverWrench,
  faSensorTriangleExclamation,
  faServer,
  faShieldCheck,
  faShieldHalved,
  faShieldKeyhole,
  faShieldSlash,
  faShieldVirus,
  faShuffle,
  faSignHanging,
  faSitemap,
  faSliders,
  faSparkles,
  faSquareBolt,
  faSquareQuestion,
  faStar,
  faStarExclamation,
  faStars,
  faSnooze,
  faSquarePen,
  faStopwatch,
  faSubtract,
  faSymbols,
  faTableCellsLock,
  faTag,
  faTennisBall,
  faTerminal,
  faThumbsDown,
  faThumbsUp,
  faTilde,
  faTimer,
  faTowerBroadcast,
  faTrash,
  faTrashCan,
  faTriangleExclamation,
  faTrophyStar,
  faUpload,
  faUpRightAndDownLeftFromCenter,
  faUser,
  faUserChart,
  faUserCircle,
  faUserCrown,
  faUserGroupCrown,
  faUserSecret,
  faVideo,
  faVideoSlash,
  faVolume,
  faVolumeSlash,
  faWallet,
  faWandMagicSparkles,
  faWarning,
  faWaveform,
  faXmark,
  faInfinity,
};
